export const environment = {
    production: false,
     baseUrl: 'https://staging.api.borrower.suknahub.com',

    dateTimePatterns: {
        date: 'YYYY-MM-DD',
        time: 'hh:mm A',
        dateTime: 'YYYY-MM-DD HH:mm',
    },
    defaultDate: new Date().toISOString(),
    versionCheck: {
        enabled: true,
        pollIntervalMs: 2 * 60 * 1000,
    },
};
